@if (authService.hasPermission(Permission.OutputsCollectionsFull)) {
  <button
    mat-icon-button
    (click)="onToggleRelease()"
    [matTooltip]="collection.releasedToClient ? 'Unrelease from client' : 'Release to client'"
    matTooltipPosition="above"
    color="error"
    >
    <mat-icon>{{ collection.releasedToClient ? 'lock_open' : 'lock' }}</mat-icon>
  </button>
}
